import React, { useState } from "react";
import "../Style/Navbar.css";

const ConnetedNav = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="max-w-[1940px] mx-auto w-full flex justify-between items-center px-6 md:px-10 py-5 relative">

      {/* Logo */}
      <div className="flex items-center">
        <a href="/" ><img
          src="/images/DarkThemeLogo-10.png"
          alt="Haoda Pay"
          className="w-[200px] h-20"
        /></a>
      </div>

      {/* Desktop Menu */}
      <ul className="hidden md:flex space-x-8 text-[16px] font-medium">
        <li><a href="/connected-bank" className="Navbar_text">Home</a></li>
        <li><a href="/connected-bank/product" className="Navbar_text">Product</a></li>
        <li><a href="/connected-bank/about-us" className="Navbar_text">About Us</a></li>
        <li><a href="/connected-bank/contact-us" className="Navbar_text">Contact</a></li>
      </ul>

      {/* Desktop Button */}
      <a href="https://merchant.haodapay.com/login" target="_blank"> <button className="hidden md:block text-white py-2 px-6 rounded-md hover:bg-gray-900">
        Free Trial
      </button></a>

      {/* Mobile Hamburger */}
      <div
        className="md:hidden cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <div className={`w-6 h-1 bg-white mb-1 transition ${open ? "rotate-45 translate-y-2" : ""}`}></div>
        <div className={`w-6 h-1 bg-white mb-1 transition ${open ? "opacity-0" : ""}`}></div>
        <div className={`w-6 h-1 bg-white transition ${open ? "-rotate-45 -translate-y-2" : ""}`}></div>
      </div>

      {/* Mobile Menu */}
      {open && (
        <div className="absolute top-20 left-0 w-full mobile_menu p-6 text-white shadow-md md:hidden z-20 animate-slideDown">
          <ul className="flex flex-col space-y-6 text-lg font-semibold">
            <li><a href="/connected-bank" onClick={() => setOpen(false)}>Home</a></li>
            <li><a href="/connected-bank/product" onClick={() => setOpen(false)}>Product</a></li>
            <li><a href="/connected-bank/about-us" onClick={() => setOpen(false)}>About Us</a></li>
            <li><a href="/connected-bank/contact-us" onClick={() => setOpen(false)}>Contact</a></li>
          </ul>

          <button className="mt-6 text-white py-3 px-4 rounded-md w-full">
            Free Trial
          </button>
        </div>
      )}
    </nav>
  );
};

export default ConnetedNav;
